export default "__VITE_ASSET__DYbLffdk__"